import { _converse, api, converse, u } from '@converse/headless';
import BaseModal from 'plugins/modal/modal.js';
import tplMUCInviteModal from './templates/muc-invite.js';
import { __ } from 'i18n';

import '../styles/muc-invite-modal.scss';

export default class MUCInviteModal extends BaseModal {
    static properties = {
        selectedContacts: { type: Array },
        searchQuery: { type: String },
        _submitting: { type: Boolean },
    };

    constructor(options) {
        super(options);
        this.id = 'converse-muc-invite-modal';
        this.muc = options.muc;

        // Початкові значення
        this.selectedContacts = [];
        this.searchQuery = '';
        this._submitting = false;
    }

    renderModal() {
        return tplMUCInviteModal(this);
    }

    renderModalFooter() {
        return ''; // Футер перенесено в основний шаблон для дизайну Sonata
    }

    getModalTitle() {
        return __('Запросити до групи');
    }

    // Пошук контактів
    onSearch(ev) {
        this.searchQuery = ev.target.value || '';
        this.requestUpdate();
    }

    // Геттер для фільтрації контактів
    get rosterContacts() {
        const query = (this.searchQuery || '').toLowerCase();
        const contacts = _converse.roster?.models || [];

        if (!query) return contacts;

        return contacts.filter((m) => {
            const name = (m.getDisplayName() || m.get('jid') || '').toLowerCase();
            const jid = m.get('jid').toLowerCase();
            return name.includes(query) || jid.includes(query);
        });
    }

    // Перемикач вибору контакту
    toggleContact(jid) {
        if (!jid) return;

        const selected = [...(this.selectedContacts || [])];
        if (selected.includes(jid)) {
            this.selectedContacts = selected.filter((j) => j !== jid);
        } else {
            this.selectedContacts = [...selected, jid];
        }
        this.requestUpdate();
    }

    // Відправка запитів
    async submitInvites() {
        if (!this.selectedContacts || this.selectedContacts.length === 0 || this._submitting) {
            return;
        }

        this._submitting = true;
        this.requestUpdate();

        // Отримуємо причину з textarea через shadowRoot/renderRoot
        const reasonInput = this.renderRoot?.querySelector('#invite-reason');
        const reason = reasonInput?.value?.trim() || '';

        try {
            // Використовуємо стандартний метод directInvite моделі кімнати
            this.selectedContacts.forEach((jid) => {
                this.muc.directInvite(jid, reason);
                // Hooked here (the UI action), not inside directInvite()
                // itself -- that's reused for the brand-new-room case
                // (group-created only, no per-member invited lines) and
                // could later be reused elsewhere too (spec pitfall).
                u.muc.sendGroupEvent(this.muc, 'member-invited', { target_jid: jid });
            });

            // Закриваємо модалку після успішної відправки
            this.modal.hide();
        } catch (e) {
            console.error('Invite Error:', e);
            api.alert('error', __('Помилка'), __('Не вдалося надіслати запрошення'));
        } finally {
            this._submitting = false;
            this.requestUpdate();
        }
    }
}

if (!customElements.get('converse-muc-invite-modal')) {
    customElements.define('converse-muc-invite-modal', MUCInviteModal);
}
